<template>
  <div class="home">
    <p class="h1">Paises</p>
    <SearchBar/>
    <Filters />
    <CardList />
  </div>
  <p class="h1 text-center">Creado por</p>
  <div class="d-flex justify-content-center">
    <div class="card m-4 shadow-lg" style="width: 18rem;">
      <img src="../assets/linkedInPhoto.jpeg" class="card-img-top p-1 border" title="Jose Arpaia" alt="Jose Arpaia">
      <div class="card-body">
        <p class="card-title h1">Jose Arpaia</p>
        <p class="card-text">Web Developer</p>
        <a href="https://josearpaiaq.netlify.app/" target="blank" class="btn btn-outline-success">Web Site</a>
      </div>
    </div>
  </div>
</template>

<script>
import CardList from '../components/CardList.vue'
import Filters from '../components/Filters.vue'
import SearchBar from '../components/SearchBar.vue'
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
    CardList,
    Filters,
    SearchBar
  }
}
</script>
